module.exports = __webpack_public_path__ + "media/images/stanford_on_broadway/Dec18_Broadway_Simone_CR-p-500-232d89f97de63e8d2209ea68eaa70294.jpg";